(ns practitest.frontend.integration-settings.azure-entity-mapping.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::azure-entity-mapping
 (fn [db _]
   (:azure-entity-mapping db)))

(re-frame/reg-sub
 ::loading?
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:loading? m)))

(re-frame/reg-sub
 ::data
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:data m)))

(re-frame/reg-sub
 ::integration-name
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:integration-name m)))

(re-frame/reg-sub
 ::issues-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:issues_sync_enabled data true)))

(re-frame/reg-sub
 ::requirements-sync-enabled?
 :<- [::data]
 (fn [data _]
   (:requirements_sync_enabled data true)))

(re-frame/reg-sub
 ::selected-project-ids
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:selected-project-ids m #{})))

(re-frame/reg-sub
 ::available-projects
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:available-projects m [])))

(re-frame/reg-sub
 ::projects-loading?
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:projects-loading? m false)))

(re-frame/reg-sub
 ::project-work-item-types
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:project-work-item-types m {})))

(re-frame/reg-sub
 ::project-types-loading-set
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:project-types-loading m #{})))

(re-frame/reg-sub
 ::project-types-loading?
 :<- [::project-types-loading-set]
 (fn [loading-set [_ azure-project-id]]
   (contains? loading-set azure-project-id)))

(re-frame/reg-sub
 ::saving?
 :<- [::azure-entity-mapping]
 (fn [m _]
   (:saving? m false)))

(re-frame/reg-sub
 ::dirty?
 :<- [::azure-entity-mapping]
 (fn [m _]
   (let [data       (:data m)
         saved-data (:saved-data m)]
     (and (some? saved-data)
          (not= data saved-data)))))
